// extracted by mini-css-extract-plugin
export default {"checkbox":"_2UKKy","label-unset-font":"_3pJcc","labelUnsetFont":"_3pJcc"};